export default {"src":"/_next/static/media/playStoreBlack.82b17a51.svg","height":48,"width":162};